import { Component, input } from "@angular/core";

import { CarouselStyleModel } from "./model/carousel-style-model";
import { CarouselModel } from "./model/carousel-model";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { NgClass } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "portal-carousel",
  templateUrl: "./carousel.component.html",
  styleUrls: ["./carousel.component.scss"],
  standalone: true,
  imports: [CarouselModule, NgClass, TranslatePipe],
})
export class CarouselComponent {
  readonly model = input<CarouselModel>();
  readonly style = input<CarouselStyleModel>({
    slideIntervalInMs: 5000,
    leadingColorCode: "",
    textAlignment: "left",
  });
}
